module.exports = __webpack_public_path__ + "img/logo.daf221bc.png";